module.exports = __webpack_public_path__ + "static/media/download.dea831c3.svg";